import React from "react";
import BlockComponent from "./BlockComponent";

const NosEngagements: React.FC = () => {
  return (
    <BlockComponent titre="Nos engagements" card>
      <div id="nos-engagements">
        <p>
          <ul className="text-md mt-2 list-inside list-disc space-y-4">
            <li>
              <b className="text-redAccent">Auprès de notre écosystème</b>, notre rigueur et notre aptitude à former des joueurs et des entraineurs
              bénéficie directement au secteur dans lequel nous nous trouvons. Nous voulons continuer dans ce sens, tout en améliorant davantage nos
              outils et programmes.
            </li>
            <li>
              <b className="text-redAccent">Auprès des éditeurs de jeu</b>, nous intervenons régulièrement pour dialoguer autour des questions de la
              formation et de la prise en main des jeunes talents.
            </li>
            <li>
              <b className="text-redAccent">Auprès de la société</b>, nous souhaitons activement participer au développement d'un système viable
              d'esport - études, et avons à cœur de dialoguer avec les parents de nos talents pour les accompagner dans l’éducation de leurs enfants.
            </li>
          </ul>
        </p>
      </div>
    </BlockComponent>
  );
};

export default NosEngagements;
